var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "padding-y-4xl",
      staticStyle: { background: "var(--white)" },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            staticClass: "display-flex flex-row",
            staticStyle: { gap: "var(--grid-gutter-x-width)" },
          },
          [
            _c(
              "div",
              { staticClass: "flex-grow-0 margin-right-xl" },
              [_c("wa-logo-flag", { attrs: { "logo-size": "2xl" } })],
              1
            ),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "row roomy laptop:align-middle" }, [
                _c("div", { staticClass: "column-12 laptop:column-8" }, [
                  _c("h2", { staticClass: "h3" }, [_vm._v("Font Awesome")]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "line-length-2xl" },
                    [
                      _vm._v(
                        "\n              Font Awesome is the world's most popular icon set and toolkit. Our latest release has\n              "
                      ),
                      _c("site-link", { attrs: { to: _vm.$search() } }, [
                        _vm._v(
                          _vm._s(_vm.$counts.icons.all.formatted) + " icons"
                        ),
                      ]),
                      _vm._v(
                        "\n              in " +
                          _vm._s(_vm.categoriesCount) +
                          " categories across " +
                          _vm._s(_vm.$counts.totalLatestStylesWithoutBrands) +
                          " styles (plus\n              "
                      ),
                      _c(
                        "site-link",
                        {
                          attrs: {
                            to: _vm.$search({ iconCollections: ["brands"] }),
                          },
                        },
                        [_vm._v("brands")]
                      ),
                      _vm._v(
                        "!), with even more on the way. Get icons into your projects fast\n              with Font Awesome!\n            "
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "column-12 margin-top-md laptop:column-4 laptop:text-right laptop:margin-top-0",
                  },
                  [
                    _c(
                      "site-link",
                      {
                        staticClass: "button margin-0",
                        staticStyle: {
                          "--link-decoration-style": "none",
                          "--link-decoration-line": "none",
                          "--tag-link-hover-color": "var(--fa-navy)",
                        },
                        attrs: { to: _vm.$search() },
                      },
                      [
                        _vm._v(
                          "\n              View All " +
                            _vm._s(_vm.$counts.icons.all.formatted) +
                            " Icons\n              "
                        ),
                        _c("font-awesome-icon", {
                          staticClass: "margin-left-xs",
                          attrs: {
                            icon: _vm.$v6.solid.faArrowRight,
                            "fixed-width": "",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }